module.exports = __webpack_public_path__ + "static/img/s43.43e33da7.png";